<div class="box-user-item-container">
  <div class="box-user-item">
    <div class="box-user-item-image">
      <img class="item-picture" src="{{ userItem?.photo }}" />
    </div>
    <div class="item-description">{{ userItem?.fullName }}</div>
    <div
      *ngIf="userItem?.visualizedDate; else dateUnavailable"
      class="item-date"
    >
      {{ userItem?.visualizedDate | date: "dd/MM/yyyy 'às' HH:mm" }}
    </div>
    <ng-template #dateUnavailable>
      <div class="item-date">Informação indisponível</div>
    </ng-template>
  </div>
</div>
